import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a3dd06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "circle-icon"
}
const _hoisted_4 = ["data-cy"]
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  viewBox: "0 0 12 13",
  fill: "none"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.6251 0.500122H7.62519C7.55071 0.50002 7.47794 0.522396 7.41639 0.564323C7.35484 0.606249 7.30737 0.665776 7.2802 0.735116C7.25178 0.80293 7.24422 0.877673 7.25846 0.949805C7.27271 1.02194 7.30813 1.08819 7.3602 1.14011L9.00015 2.75506L4.27528 7.40495C4.18215 7.49862 4.12988 7.62535 4.12988 7.75744C4.12988 7.88953 4.18215 8.01625 4.27528 8.10993C4.32158 8.15717 4.3768 8.19475 4.43774 8.2205C4.49867 8.24625 4.56411 8.25965 4.63027 8.25992C4.76073 8.26071 4.88633 8.21047 4.98026 8.11993L9.72014 3.45505L11.3651 5.07501C11.3997 5.11006 11.441 5.13785 11.4865 5.15674C11.532 5.17562 11.5808 5.18524 11.6301 5.185C11.68 5.18516 11.7294 5.17494 11.7751 5.155C11.8426 5.12627 11.9 5.07813 11.94 5.01671C11.9801 4.95528 12.001 4.88334 12.0001 4.81001V0.875113C11.9988 0.776062 11.9589 0.681432 11.8888 0.611387C11.8188 0.541341 11.7241 0.501417 11.6251 0.500122Z",
  fill: "#387DFF"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9.24976 5.81004C9.11716 5.81004 8.98998 5.86272 8.89622 5.95649C8.80245 6.05025 8.74978 6.17743 8.74978 6.31003V11.4999H0.999974V3.7501H6.18484C6.31745 3.7501 6.44462 3.69742 6.53839 3.60365C6.63215 3.50989 6.68483 3.38271 6.68483 3.25011C6.68483 3.1175 6.63215 2.99033 6.53839 2.89657C6.44462 2.8028 6.31745 2.75012 6.18484 2.75012H0.934976C0.687005 2.75012 0.44919 2.84863 0.273848 3.02397C0.0985061 3.19931 0 3.43713 0 3.6851L0 11.5599C-3.51443e-06 11.8083 0.0983428 12.0467 0.273543 12.2228C0.448742 12.3989 0.686546 12.4986 0.934976 12.4999H8.80977C9.05907 12.4999 9.29816 12.4008 9.47444 12.2246C9.65072 12.0483 9.74975 11.8092 9.74975 11.5599V6.31003C9.74975 6.17743 9.69707 6.05025 9.60331 5.95649C9.50954 5.86272 9.38237 5.81004 9.24976 5.81004Z",
  fill: "#387DFF"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  style: {"margin-top":"-15px"},
  class: "tw-h-[10px] tw-w-[30px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")!
  const _component_LottieAnimation = _resolveComponent("LottieAnimation")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`level level-${_ctx.level}`)
  }, [
    (_openBlock(), _createElementBlock("div", {
      key: _ctx.index,
      class: _normalizeClass(`menu_item ${
        _ctx.path === _ctx.menuItem?.url || _ctx.isSelected || _ctx.isAssessChecklist()
          ? 'active'
          : ''
      } ${
        _ctx.menuItem?.children && _ctx.isSelected ? 'has-child expand' : ''
      } ${_ctx.getClassActive()}`),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectItem && _ctx.selectItem(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.level === 0 && _ctx.menuItem?.icon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.menuItem?.icon,
              alt: "icon"
            }, null, 8, _hoisted_2))
          : (_ctx.level === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true),
        _createElementVNode("span", {
          id: "item-name",
          "data-cy": `item-collapsibale-${_ctx.menuItem?.dataCy}`,
          class: _normalizeClass(`item-name ${_ctx.danger ? 'danger' : ''} ${
            _ctx.path === _ctx.menuItem?.url || _ctx.isSelected || _ctx.isAssessChecklist()
              ? 'active'
              : ''
          }`)
        }, _toDisplayString(_ctx.menuItem?.title), 11, _hoisted_4)
      ]),
      (_ctx.level === 0 && !_ctx.isSubscriptionTab())
        ? (_openBlock(), _createBlock(_component_ArrowIcon, {
            key: 0,
            class: "right-arrow",
            color: _ctx.danger ? '#F7553C' : undefined,
            width: 6.661,
            height: 10
          }, null, 8, ["color"]))
        : _createCommentVNode("", true),
      (_ctx.isSubscriptionTab() && !_ctx.isLoadingStripURL)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.isSubscriptionTab() && _ctx.isLoadingStripURL)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_LottieAnimation, {
              ref: "anim",
              "animation-data": _ctx.getProgressAnimation(),
              "auto-play": true,
              loop: true
            }, null, 8, ["animation-data"])
          ]))
        : _createCommentVNode("", true)
    ], 2))
  ], 2))
}